import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

export const AgencyContext = createContext(null);

export function AgencyContextProvider({ children }) {
  const [agency, setAgency]   = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = () => {
    setLoading(true);
    axios.get("https://api.komorotel.com/api/agency/me", { withCredentials: true })
      .then(r => setAgency(r.data))
      .catch(() => setAgency(null))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchMe(); }, []);

  return (
    <AgencyContext.Provider value={{ agency, setAgency, loading, refetch: fetchMe }}>
      {children}
    </AgencyContext.Provider>
  );
}

export const useAgency = () => useContext(AgencyContext);